import React, { useState, useRef, useEffect, useContext, useCallback } from 'react';
import styles from './Kalkulator.module.css';
import { BookOpen, Plus, Trash2, Layers, X,Download,Grid3X3, Box, File } from 'lucide-react';
import { AppContext } from 'context/AppContext';
import { useApiPapier } from 'hooks/useApiPapier';
import { UIContext } from 'context/UIContext';
import { useZamowienia } from 'hooks/useZamowienia';
import { TechnologyContext } from 'context/TechnologyContext';

const Kalkulator = () => {
  const uiContext = useContext(UIContext);
    const techcontext = useContext(TechnologyContext);
  
  
  const [callForPaper] = useApiPapier();
  const {getElementy} = useZamowienia();
  const { listaPapierow, listaPapierowWyszukiwarka } = useContext(AppContext);

  
  const [sections, setSections] = useState([
    { id: 1, pages: 80, thickness: 0.0648, label: 'Środek', papier_id: 10, width: 210, height: 297 },
    { id: 2, pages: 4, thickness: 0.20, label: 'Okładka', papier_id: 83 , width: 210, height: 297}
  ]);
  
  const [totalThickness, setTotalThickness] = useState(0);
    const [totalWeight, setTotalWeight] = useState(0);
  const [nr, setNr] = useState();
  const [naklad, setNaklad] = useState(1);
  const [warstwy, setWarstwy] = useState(1);
  const [iloscNaWarstwie, setIloscNaWarstwie] = useState(1);
  const [rok, setRok] = useState(2026);

  const scrollRef = useRef(null);

  // 1. Pobranie danych z API przy montowaniu
  useEffect(() => {
    techcontext.setDaneTech([])
    callForPaper();
  }, []);

  // 2. Funkcja obliczająca jednostkową grubość arkusza
  // Pobieranie danych papieru po ID
  const getPapierById = useCallback((id) => {
    return listaPapierow?.find(x => x.id == id);
  }, [listaPapierow]);

  // Obliczanie grubości pojedynczego arkusza
  const obliczGruboscArkusza = useCallback((id) => {
    const papier = getPapierById(id);
    if (!papier) return 0.1;
    return (parseFloat(papier.gramatura) / 1000) * parseFloat(papier.bulk);
  }, [getPapierById]);


  

  // 3. Główna funkcja przeliczająca całkowity grzbiet
  const calculateThickness = useCallback(() => {
    const total = sections.reduce((sum, section) => {
      const sheets = section.pages / 2;
      // Używamy aktualnej grubości z obiektu sekcji
      return sum + (sheets * section.thickness);
    }, 0);
    
    // Dodajemy 1mm zapasu (zgodnie z Twoim oryginałem)
    const finalResult = total > 0 ? total + 1 : 0;
    setTotalThickness(finalResult.toFixed(2));
  }, [sections]);

    const calculateWeight = useCallback(() => {
    const total = sections.reduce((sum, section) => {
      const papier = getPapierById(section.papier_id);
      if (!papier) return sum;

      const gramatura = parseFloat(papier.gramatura) || 0;
      const arkusze = (parseInt(section.pages) || 0) / 2;
      const powierzchniaM2 = (section.width * section.height) / 1000000;
      
      const wagaSekcji = powierzchniaM2 * (gramatura / 1000) * arkusze;
      return sum + wagaSekcji;
    }, 0);
    
    setTotalWeight(total.toFixed(3));
  }, [sections, getPapierById]);



  // 4. Reaguj na zmiany w sekcjach lub załadowanie listy papierów
  useEffect(() => {
    calculateThickness();
    calculateWeight();
  }, [sections, calculateThickness,calculateWeight]);












  // Aktualizacja sekcji - teraz automatycznie przelicza grubość przy zmianie papier_id
  const updateSection = (id, field, value) => {
    setSections(prevSections => prevSections.map(s => {
      if (s.id === id) {
        const updatedSection = { ...s, [field]: value };
        
        // Jeśli zmieniamy papier_id, od razu aktualizujemy też thickness dla tej sekcji
        if (field === 'papier_id') {
          updatedSection.thickness = obliczGruboscArkusza(value);
        }
        return updatedSection;
      }
      return s;
    }));
  };

  const addSection = () => {
    const newId = Date.now();
    // Pobieramy domyślną grubość dla papieru o ID 1 (lub pierwszego z listy)
    const defaultThickness = obliczGruboscArkusza(1);

    setSections([
      ...sections,
      { id: newId, pages: 16, thickness: defaultThickness, label: 'Nowa sekcja', papier_id: 1, width: sections[1].width, height: sections[1].height }
    ]);

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTo({
          top: scrollRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    }, 100);
  };


const pobierzElementyZamowienia = async () => {
  // 1. Czekamy aż dane zostaną pobrane i przypisane do zmiennej data
  setNaklad(1)
  setWarstwy(1)
  const data = await getElementy(nr, rok);
  // 2. Wykonujemy resztę logiki tylko gdy mamy dane
  if (data[0] && Array.isArray(data)) {
    const sec = data.map(x => ({
      id: x.id,
      pages: x.ilosc_stron,
      // Zakładam, że obliczGruboscArkusza jest dostępna w zasięgu
      thickness: obliczGruboscArkusza(x.papier_id || 1), 
      label: x.typ_nazwa || "cos",
      papier_id: x.papier_id,
      width: x.format_x,
      height: x.format_y,
    }));

    // 3. Aktualizujemy stan sekcji
  // console.log(data)

    setSections(sec);
  }
};



  const removeSection = (id) => {
    if (sections.length > 1) {
      setSections(sections.filter(s => s.id !== id));
    }
  };


  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div onDoubleClick={() => console.table(sections)} className={styles.header}>
          <div>
            <h1 className={styles.headerTitle}>
              <BookOpen size={32} color="#b1ec10" /> 
              Kalkulator Grzbietu
            </h1>
            {/* <p className={styles.headerSubtitle}>.</p> */}
            {/* <p className={styles.headerSubtitle}>Oblicz grubość grzbietu oraz wagę...</p> */}

            {techcontext.daneTech.length > 0 ? (<p className={styles.headerSubtitle}>{techcontext.daneTech[0]?.firma_nazwa} -  {techcontext.daneTech[0]?.tytul}</p>): (<p className={styles.headerSubtitle}>Policz grzbiet oraz wage...</p>)}
            {/* // <p className={styles.headerSubtitle}>{techcontext.daneTech[0]?.firma_nazwa} -  {techcontext.daneTech[0]?.tytul}</p> */}
            
          </div>
          

          <X size={48} style={{ opacity: 0.2 } } onClick={()=>{uiContext.setShowKalkulatorGrzbietu(false )}} />
      

        </div>

        <div className={styles.body}>
          <div className={styles.scrollArea} ref={scrollRef}>
            {sections.map((section) => (
              <div key={section.id} className={styles.sectionCard}>
                <div style={{ flex: '1', minWidth: '90px' }}>
                  <label className={styles.label}>Element</label>
                  <input 
                    className={styles.input}
                    type="text"
                    value={section.label}
                    onChange={(e) => updateSection(section.id, 'label', e.target.value)}
                  />
                </div>

                <div style={{ width: '80px' }}>
                  <label className={styles.label}>Strony</label>
                  <input 
                    className={styles.input}
                    type="number"
                    min="2"
                    step="2"
                    value={section.pages}
                    onChange={(e) => updateSection(section.id, 'pages', parseInt(e.target.value) || 0)}
                  />
                </div>



                  <div style={{ width: '80px' }}>
                  <label className={styles.label}>Szer (mm)</label>
                  <input 
                    className={styles.input}
                    type="number"
                    value={section.width}
                    onChange={(e) => updateSection(section.id, 'width', parseInt(e.target.value) || 0)}
                  />
                </div>

                 <div style={{ width: '80px' }}>
                  <label className={styles.label}>Wys (mm)</label>
                  <input 
                    className={styles.input}
                    type="number"
                    value={section.height}
                    onChange={(e) => updateSection(section.id, 'height', parseInt(e.target.value) || 0)}
                  />
                </div>

                



                <div style={{ flex: '2', minWidth: '200px' }}>
                  <label className={styles.label}>Rodzaj papieru</label>
                  <select 
                    className={styles.input}
                    value={section.papier_id}
                    onChange={(e) => updateSection(section.id, 'papier_id', e.target.value)}
                  >
                    {listaPapierowWyszukiwarka && listaPapierowWyszukiwarka.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.nazwa} {option.gramatura}g {option.wykonczenie}
                      </option>
                    ))}
                  </select>
                </div>

                <button 
                  className={styles.trashBtn}
                  onClick={() => removeSection(section.id)}
                  style={{ visibility: sections.length > 1 ? 'visible' : 'hidden' }}
                >
                  <Trash2 size={20} />
                </button>
              </div>
            ))}
          </div>

          {/* <div className={styles.controls}>
            <button className={styles.btnAdd} onClick={addSection}>
              <Plus size={20} /> Dodaj element
            </button>
          </div> */}
        </div>

        <div className={styles.resultArea}>
          <div className={styles.resultAreaLeft}>
  <button className={styles.btnAdd} onClick={addSection}>
              <Plus size={20} /> Dodaj element
            </button>
          </div>
          <div className={styles.resultAreaCenter}>
          <span style={{ color: '#94a3b8', fontSize: '14px', fontWeight: '500' }}>
            Przybliżona grubość grzbietu oraz waga:
          </span>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline' }}>
            <span className={styles.totalValue}>{(totalThickness* naklad * warstwy).toFixed(2)}</span>
            <span className={styles.unit}>mm</span>
            <span className={styles.unit2}> - </span>



                <span className={styles.totalWeight}>{(totalWeight * naklad * warstwy *iloscNaWarstwie).toFixed(2)}</span>
                <span className={styles.unit}>kg</span>
          </div>
          
          <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '25px'}}>


            



          </div>
          </div>
          <div className={styles.resultAreaRight}>

                              <input 
                    className={styles.inputNr}
                    placeholder='nr'
                    title='Wpisz nr zlecenia i pobierz elementy'

                    type="text"
                    value={nr}

                    onChange={(e) => setNr( e.target.value)}
                  />

                                               <input 
                    className={styles.inputNr}
                    title='Wpisz nr zlecenia i pobierz elementy'

                    type="text"
                    value={rok}
                                        onChange={(e) => setRok( e.target.value)}

                  />
                    <button 
                    title='Wpisz nr zlecenia i pobierz elementy'
                    className={styles.btnImport} onClick={pobierzElementyZamowienia}>
              <Download size={20} /> 
            </button>
          </div>


        </div>
        <div className={styles.resultAreaBottom}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#94a3b8', fontSize: '13px' }}>
              <File  color="#1c8de9" size={16} /> 
              <span>Strony: <strong>{sections.reduce((a, b) => a + (parseInt(b.pages) || 0), 0)}</strong></span>
            </div>

                       <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#94a3b8', fontSize: '13px' }}>
              <Box color="#933e3e" size={16} /> 
              <span>Ilość w paczce : </span>                           <input 
                    className={styles.inputNaklad}
                    placeholder='1'
                    title={naklad.toLocaleString()}

                    type="text"
                    value={naklad}

                    onChange={(e) => setNaklad( e.target.value)}
                  />
            </div>


                       <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#94a3b8', fontSize: '13px' }}>
              <Layers  color="#a9ac18" size={16} /> 
              <span>Warstwy : </span>                           <input 
                    className={styles.inputNaklad}
                    placeholder='1'
                    title={warstwy.toLocaleString()}

                    type="text"
                    value={warstwy}

                    onChange={(e) => setWarstwy( e.target.value)}
                  />
            </div>

                                   <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#94a3b8', fontSize: '13px' }}>
              <Grid3X3  color="#3e9392" size={16} /> 
              <span>Ilość paczek na warstwie : </span>                           <input 
                    className={styles.inputNaklad}
                    placeholder='1'
                    title={iloscNaWarstwie.toLocaleString()}

                    type="text"
                    value={iloscNaWarstwie}

                    onChange={(e) => setIloscNaWarstwie( e.target.value)}
                  />
            </div>
        </div>
      </div>
    </div>
  );
  

};

export default Kalkulator;